var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../node_modules/babel-loader/lib/index.js??ruleSet[1].rules[1].use[0]!./index.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["phillips"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["phillips"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
